import { Directive, computed, inject } from '@angular/core';
import { CustomerFacade } from '../../../facades';
import { TemplateAssertDirective } from '../template-assert.directive';

/**
 * @description
 * this is a structural directive, it will render its guarded context only if the
 * authentication state allows it, meaning: if user IS authenticated
 */

@Directive({
  standalone: true,
  selector: '[isUnVerifiedCustomer]'
})
export class IsUnVerifiedCustomerDirective extends TemplateAssertDirective {
  override readonly isMatch$$ = computed(() => this._customerFacade.isVerifiedCustomer$$() !== true);

  private _customerFacade = inject(CustomerFacade);

  constructor() {
    super();
  }
}
